export default "__VITE_ASSET__BewKB_JU__"